import { PlaceHolderContainer } from "./styles";
import { useImageSrc } from "../../utils/imageFallback";

interface Props {
  image: string;
  image2: string;
  link: string;
}

export const AdsPlaceHolder = ({ image, image2, link }: Props) => {
  const webImage = useImageSrc(image);
  const mobileImage = useImageSrc(image2);

  function handleClick() {
    window.open(link, "_blank");
  }

  return (
    <PlaceHolderContainer onClick={handleClick} image={webImage} image2={mobileImage} />
  );
};
